var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import axios from 'axios';
import RequestError from './RequestError';
import DefaultHttpFilter from './filter/DefaultHttpFilter';
import FilterChain from './filter/FilterChain';
var CancelException = /** @class */ (function () {
    function CancelException() {
        this.reason = 'REQUEST_ABORTED';
    }
    return CancelException;
}());
export { CancelException };
export var ResponseType;
(function (ResponseType) {
    ResponseType["JSON"] = "json";
    ResponseType["ARRAYBUFFER"] = "arraybuffer";
})(ResponseType || (ResponseType = {}));
export var RequestMethod;
(function (RequestMethod) {
    RequestMethod["GET"] = "GET";
    RequestMethod["POST"] = "POST";
    RequestMethod["PUT"] = "PUT";
    RequestMethod["DELETE"] = "DELETE";
})(RequestMethod || (RequestMethod = {}));
var Requester = /** @class */ (function () {
    function Requester(baseUrl, httpFilters) {
        if (baseUrl === void 0) { baseUrl = ''; }
        if (httpFilters === void 0) { httpFilters = []; }
        var filters = __spreadArray(__spreadArray([], httpFilters, true), [DefaultHttpFilter], false);
        this.filterChain = new FilterChain(filters);
        this._axiosInstance = axios.create({
            baseURL: baseUrl,
        });
    }
    Object.defineProperty(Requester.prototype, "baseURL", {
        get: function () {
            return this._axiosInstance.defaults.baseURL;
        },
        enumerable: false,
        configurable: true
    });
    Requester.prototype.request = function (url, method, options) {
        return __awaiter(this, void 0, void 0, function () {
            var requestConfig, data, e_1, status_1, message, errors;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        requestConfig = this.buildRequestConfig(method, url, options);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this._axiosInstance.request(requestConfig)];
                    case 2:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                    case 3:
                        e_1 = _a.sent();
                        status_1 = -1;
                        message = '';
                        errors = {};
                        if (e_1.response) {
                            status_1 = e_1.response.status;
                            message = e_1.response.data.message;
                            errors = e_1.response.data.errors;
                        }
                        else if (e_1.request) {
                            message = 'Error making request! Got no response!';
                        }
                        else {
                            message = 'Unknown request error occurred!';
                        }
                        throw new RequestError(status_1, message, errors);
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    Requester.prototype.buildRequestConfig = function (method, url, options) {
        return this.filterChain.execute(__assign({ responseType: 'json', method: method, url: url }, options));
    };
    return Requester;
}());
export default Requester;
